import { t } from "i18next";
import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { Period } from "../../../../interfaces/planning";

interface PeriodModalProps {
    show: boolean;
    selectedWeeks: string[];
    editingPeriod?: Period | null;
    onSave: (name: string, color: string) => void;
    onClose: () => void;
}

export function PeriodModal(props: PeriodModalProps) {
    const [name, setName] = useState('');
    const [color, setColor] = useState('#ccffcc');

    // Update form when editing a period
    useEffect(() => {
        if (props.editingPeriod) {
            setName(props.editingPeriod.name);
            setColor(props.editingPeriod.color);
        } else {
            setName('');
            setColor('#ccffcc');
        }
    }, [props.editingPeriod, props.show]);

    const handleSave = (event: any) => {
        event.preventDefault();
        if (name.trim() === '') {
            alert(t("Please enter a name for the period"));
            return;
        }
        props.onSave(name, color);
        setName('');
        setColor('#ccffcc');
    }

    const handleClose = () => {
        setName('');
        setColor('#ccffcc');
        props.onClose();
    }

    const weeks = props.editingPeriod ? props.editingPeriod.weeks : props.selectedWeeks;
    const isEditing = !!props.editingPeriod;

    return (
        <Modal show={props.show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>{isEditing ? t("Edit Period") : t("Define Period")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSave}>
                    <Form.Group className="mb-3">
                        <Form.Label>{t("Selected weeks")}: {weeks.length}</Form.Label>
                        <div className="text-muted small">
                            {weeks.join(', ')}
                        </div>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="periodName">
                        <Form.Label>{t("Period name")}</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder={t("e.g., Preparation Period")}
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="periodColor">
                        <Form.Label>{t("Background color")}</Form.Label>
                        <div className="d-flex align-items-center gap-2">
                            <Form.Control
                                type="color"
                                value={color}
                                onChange={(e) => setColor(e.target.value)}
                                style={{ width: '60px', height: '40px' }}
                            />
                            <Form.Control
                                type="text"
                                value={color}
                                onChange={(e) => setColor(e.target.value)}
                                placeholder="#ccffcc"
                            />
                        </div>
                    </Form.Group>

                    <div className="d-flex justify-content-end gap-2">
                        <Button variant="secondary" onClick={handleClose}>
                            {t("Cancel")}
                        </Button>
                        <Button variant="primary" type="submit">
                            {t("Save")}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
}
